import { MultipleChoiceSvarmulighed } from './MultipleChoiceSvarmulighed'; 
export class MultipleChoiceSpoergsmaal {
        public id: string;
        public spoergsmaal: string;
        public delopgaveId: string;
        public order: number;
        public multipleChoiceSvarmuligheder: MultipleChoiceSvarmulighed[];
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/MultipleChoiceSpoergsmaal.ts